import { BaseService } from '@/modules/core/app/services/abstracts/BaseService';
import { Team } from '@/modules/team/models/Team';
import TeamResource from '@/modules/team/resources/TeamResource';
import EventBus from '/@/modules/core/app/helpers/EventBus';
import { commits } from '@/modules/core/app/helpers/store';
import AuthService from '@/modules/auth/services/AuthService';
import { TeamEvent } from '@/modules/team/enums/TeamEvent';

export class TeamSetTeamService extends BaseService {
  resource: typeof TeamResource;

  constructor() {
    super();
    this.resource = TeamResource;
  }

  async setCurrentTeam(team?: Team): Promise<Team | undefined> {
    await this.resource.setCurrentTeam(team?.id);

    await AuthService.refreshAuthUser();
    commits.auth.setCurrentTeam(team);
    EventBus.signal(TeamEvent.ON_TEAM_CHANGED, team);

    return team;
  }

  async setCurrentTeamQuietly(team?: Team): Promise<void> {
    await this.resource.setCurrentTeam(team?.id);
  }

  async setCheckoutSessionTeamAsCurrentTeam(sessionId: string): Promise<Team | undefined> {
    const team: Team = await this.resource.setCheckoutSessionTeamAsCurrentTeam(sessionId);

    await AuthService.refreshAuthUser();
    commits.auth.setCurrentTeam(team);
    EventBus.signal(TeamEvent.ON_TEAM_CHANGED, team);

    return team;
  }
}

export default new TeamSetTeamService();
